module.exports = __webpack_public_path__ + "img/save-error.2c409098.svg";